import { styled } from "styled-components";

import { colorCSS, fontSizes, theme } from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

export const Banner = styled.div<{
    themeInitial?: string;
}>`
    ${redundantCssFromKebab("text-align", "left")}
    ${({ themeInitial }) =>
        themeInitial
            ? `padding: 1.5rem; `
            : `padding: 1rem;
    @media (max-width: 992px) {
      padding: 0;
      margin-bottom: 1.5rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  `}
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 100%;
    ${({ themeInitial }) =>
        themeInitial &&
        `background-color: ${colorCSS(`${themeInitial}50`, 0.4)};`}
`;

export const BannerIcon = styled.div<{
    themeInitial?: string;
}>`
    svg {
        ${redundantCssFromKebab("height", "1.2rem")}
        ${redundantCssFromKebab("margin-left", "0.4rem")}
        ${redundantCssFromKebab("margin-right", "0.8rem")}
        ${redundantCssFromKebab("width", "auto")}

        path {
            fill: ${({ themeInitial }) =>
                colorCSS(themeInitial ? `${themeInitial}200` : "N100")};
        }
    }
`;

export const BannerTitleContainer = styled.div<{
    themeInitial?: string;
}>`
    ${redundantCssFromKebab("display", "flex")}
    ${({ themeInitial }) =>
        themeInitial && `line-height: 1rem; padding-bottom: 0.25rem;`}
`;

export const BannerTitle = styled.div`
    ${redundantCssFromKebab("width", "100%")}

    p {
        ${redundantCssFromKebab("color", `${colorCSS("N800")}`)}
        ${redundantCssFromKebab("font-weight", "normal")}
        ${redundantCssFromKebab("font-family", `${theme.fontFamily.text}`)}
        ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
        ${redundantCssFromKebab("line-height", "1.25rem")}
        ${redundantCssFromKebab("padding-right", "0.3rem")}
        ${redundantCssFromKebab("margin-bottom", "0.5rem !important")}
    }
`;

export const BannerDescription = styled.div<{
    themeInitial?: string;
}>`
    ${redundantCssFromKebab("color", `${colorCSS("N400")}`)}
    ${redundantCssFromKebab("font-size", `${fontSizes.xxs}`)}
    ${({ themeInitial }) =>
        themeInitial && `line-height: 1rem; margin-bottom: 1rem;`}

    p {
        margin-bottom: 0.5rem;
    }

    p:last-child {
        margin-bottom: 0;
    }

    ul {
        margin-top: 0.25rem;
        margin-bottom: 0.5rem;
        padding-left: 1.5rem;
    }

    li {
        margin-bottom: 0.25rem;
    }
`;
